import { Injectable, signal } from '@angular/core';
import { IBonusReward } from '../interfaces';
import { RewardsGroupsWithProducts, RewardsPackages } from '../types';

@Injectable()
export class RewardsManagerService {
  
  public kiosksGroups = signal<RewardsGroupsWithProducts>([]);
  public packages = signal<RewardsPackages>([]);

  public getFormattedKiosksGroupsWithRewards(value: IBonusReward[]): RewardsGroupsWithProducts {
    const groups = this.kiosksGroups();

    if (value?.length) {
      return groups.map(group => ({
        ...group,
        products: group.products.map(product => {
          const reward = value.find(x => x.productId === product.id);
          return {
            ...product,
            isSelected: !!reward,
            count: reward ? reward.count : 1
          };
        })
      }));
    }

    return groups;
  }

  public getFormattedPackagesWithRewards(value: IBonusReward[]): RewardsPackages {
    const packages = this.packages();

    if (value?.length) {
      return packages.map(pkg => {
          const reward = value.find(x => x.packageId === pkg.id);
          return {
            ...pkg,
            isSelected: !!reward,
            count: reward ? reward.count : 1
          };
      });
    }

    return packages;
  }
}

